import { render } from "./index.vue?vue&type=template&id=60fd71c4&scoped=true&lang=javascript&bindings={}"
import script from "./Fragments.js?vue&type=script&lang=js"
export * from "./Fragments.js?vue&type=script&lang=js"

import "./Fragments.scss?vue&type=style&index=0&id=60fd71c4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-60fd71c4"

export default script